/* ==========================================================================
   INVELO: premium custom-fit 3D car mats
   Landing page JS ADAPTED for a Shopify product (form /cart/add).
   - Vehicle configurator (make/model/year) kept in full.
   - Product with 1 option "Kit" and 2 variants: Básico / Completo.
     PRICES DIFFER by variant: when the kit is selected, the JS updates
     the displayed price (total/sticky) AND #pc-variant-id.
   - The BUY buttons submit form #primecar-form; they only submit when the
     vehicle is configured (otherwise they scroll to the configurator).
   - EDELKOFFER Meta pixel (1002349139486837): ViewContent on load;
     AddToCart + InitiateCheckout on BUY, before the jump to the White store.
     DarkRouter also fires fbq if the pixel already exists (init in the theme).
   ========================================================================== */

var INVELO_PIXEL_ID = '1002349139486837';

function inveloCookie(name) {
    try {
        var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
        return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
}

function inveloEventId(prefix) {
    return prefix + '.' + Date.now() + '.' + Math.random().toString(36).slice(2, 8);
}

function inveloFbc() {
    var c = inveloCookie('_fbc');
    if (c) return c;
    try {
        var fbclid = new URLSearchParams(window.location.search).get('fbclid');
        if (fbclid) return 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + fbclid;
    } catch (e) {}
    return '';
}

function trackMeta(event, params, eventID) {
    try {
        if (typeof fbq === 'function') {
            fbq('track', event, params || {}, eventID ? { eventID: eventID } : {});
        }
    } catch (e) {}
}

function metaContentParams() {
    var vid = '';
    try {
        vid = String((window.PC_VARIANTS && (window.PC_VARIANTS[selectedKit === 'basico' ? 'básico' : 'completo'] || window.PC_VARIANTS['completo'] || window.PC_VARIANTS['básico'])) || '');
    } catch (e) {}
    var input = document.getElementById('pc-variant-id');
    if (!vid && input && input.value) vid = String(input.value);
    return {
        content_ids: vid ? [vid] : ['invelo-tapete'],
        content_type: 'product',
        content_name: selectedKit === 'basico' ? 'Kit Without Trunk Mat' : 'Kit With Trunk Mat',
        content_category: 'floor mats',
        value: PRICES[selectedKit] || 0,
        currency: 'EUR',
        num_items: 1
    };
}

// Capture UTM params from the URL on first load (kept for attribution)
(function () {
    try {
        var p = new URLSearchParams(window.location.search);
        var src = p.get('utm_source') || (p.get('gclid') && 'google') || '';
        var med = p.get('utm_medium')   || '';
        var cam = p.get('utm_campaign') || '';
        if (src || med || cam) {
            sessionStorage.setItem('invelo_utms', JSON.stringify({ source: src, medium: med, campaign: cam }));
        }
    } catch (_) {}
})();

// Landing kit map -> exact name of the Shopify "Kit" option (lowercase)
var KIT_TO_OPTION = {
    'basico':   'básico',
    'completo': 'completo'
};

// Fallbacks (in case the Shopify product has no prices set yet)
var FALLBACK_PRICES    = { basico: 18.90, completo: 28.90 };
var FALLBACK_ORIGINALS = { basico: 28.90, completo: 42.10 };

function pcVariantData(kit) {
    var data = window.PC_VARIANT_DATA || {};
    return data[KIT_TO_OPTION[kit]] || null;
}

// Prices read from the Shopify product (window.PC_VARIANT_DATA), with a fixed fallback
var PRICES = {
    basico:   (pcVariantData('basico')   && typeof pcVariantData('basico').price   === 'number') ? pcVariantData('basico').price   : FALLBACK_PRICES.basico,
    completo: (pcVariantData('completo') && typeof pcVariantData('completo').price === 'number') ? pcVariantData('completo').price : FALLBACK_PRICES.completo
};
var ORIGINALS = {
    basico:   (pcVariantData('basico')   && pcVariantData('basico').compareAt)   ? pcVariantData('basico').compareAt   : FALLBACK_ORIGINALS.basico,
    completo: (pcVariantData('completo') && pcVariantData('completo').compareAt) ? pcVariantData('completo').compareAt : FALLBACK_ORIGINALS.completo
};
var DISCOUNTS = {
    basico:   Math.round((1 - (PRICES.basico   / ORIGINALS.basico))   * 100) || 31,
    completo: Math.round((1 - (PRICES.completo / ORIGINALS.completo)) * 100) || 29
};

var selectedKit = 'completo';
var vehicleConfigured = false;

function fmt(v, kit) {
    if (window.INVELO_I18N && typeof window.INVELO_I18N.formatMoney === 'function') {
        return window.INVELO_I18N.formatMoney(v, kit);
    }
    return '€' + Number(v).toFixed(2).replace('.', ',');
}

// Updates the hidden #pc-variant-id input for the selected kit
function applyVariantForKit(kit) {
    var variants = window.PC_VARIANTS || {};
    var vid = variants[KIT_TO_OPTION[kit]] || variants[kit] || variants['basico'] || variants['básico'] || variants['completo'];
    if (!vid) {
        var keys = Object.keys(variants);
        if (keys.length) vid = variants[keys[0]];
    }
    var input = document.getElementById('pc-variant-id');
    if (input && vid) input.value = vid;
    return vid;
}

function syncBuyButtons() {
    var vid = document.getElementById('pc-variant-id') ? document.getElementById('pc-variant-id').value : '';
    ['btnComprar', 'btnComprarSticky'].forEach(function (id) {
        var b = document.getElementById(id);
        if (!b) return;
        if (vid) b.setAttribute('data-variant-id', vid);
    });
}

// Direct checkout to the White store via DarkRouter, WITHOUT showing the /cart page.
// Adds the item to the storefront (Vitrinni) cart via AJAX and triggers the
// DarkRouter checkout interception (processCartAndRedirect redirects to the White store).
// We do NOT use the DarkRouter "buy now" because that function has a URL bug.
function readDrState() {
    var scripts = document.querySelectorAll('script[data-dr-injected="true"]');
    for (var i = 0; i < scripts.length; i++) {
        var t = scripts[i].textContent || '';
        var shop = (t.match(/shopDomain:\s*'([^']+)'/) || [])[1];
        var mapRaw = (t.match(/MAP_STANDARD:\s*(\{[\s\S]*?\})/) || [])[1];
        var promoRaw = (t.match(/MAP_PROMO:\s*(\{[\s\S]*?\}|\[[^\]]*\])/) || [])[1];
        if (!shop || !mapRaw) continue;
        try {
            var promo = {};
            if (promoRaw && promoRaw.charAt(0) === '{') promo = JSON.parse(promoRaw);
            return { shopDomain: shop, MAP_STANDARD: JSON.parse(mapRaw), MAP_PROMO: promo };
        } catch (e) {
            console.warn('[INVELO] DR_STATE parse failed', e);
        }
    }
    return null;
}

function mapVariantId(state, id) {
    if (!state || !id) return null;
    id = String(id);
    if (state.MAP_PROMO && state.MAP_PROMO[id]) return state.MAP_PROMO[id];
    if (state.MAP_STANDARD && state.MAP_STANDARD[id]) return state.MAP_STANDARD[id];
    return null;
}

function collectAttr(extra) {
    var stored = {};
    try { stored = JSON.parse(localStorage.getItem('dr_attr') || '{}'); } catch (e) {}
    try {
        var p = new URLSearchParams(window.location.search);
        ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid','ttclid','sck','xcod'].forEach(function (k) {
            var v = p.get(k); if (v) stored[k] = v;
        });
    } catch (e) {}
    ['sck','xcod'].forEach(function (k) {
        if (!stored[k]) {
            var c = inveloCookie(k);
            if (c) stored[k] = c;
        }
    });
    try {
        var lead = JSON.parse(localStorage.getItem('lead') || 'null');
        if (lead) {
            if (!stored.sck && lead.sck) stored.sck = lead.sck;
            if (!stored.xcod && lead.xcod) stored.xcod = lead.xcod;
        }
    } catch (e) {}
    var fbp = inveloCookie('_fbp');
    var fbc = inveloFbc();
    if (fbp) { stored['_fbp'] = fbp; stored['fbp'] = fbp; }
    if (fbc) { stored['_fbc'] = fbc; stored['fbc'] = fbc; }
    if (extra) {
        Object.keys(extra).forEach(function (k) {
            if (extra[k]) stored[k] = extra[k];
        });
    }
    try { localStorage.setItem('dr_attr', JSON.stringify(stored)); } catch (e) {}
    return stored;
}

function attrQuery(extra) {
    var stored = collectAttr(extra);
    var parts = [];
    Object.keys(stored).forEach(function (k) {
        if (!stored[k]) return;
        parts.push(k + '=' + encodeURIComponent(stored[k]));
        parts.push('attributes[' + k + ']=' + encodeURIComponent(stored[k]));
    });
    return parts.join('&');
}

function fireUtmifyIc() {
    try {
        var lead = null;
        try { lead = JSON.parse(localStorage.getItem('lead') || 'null'); } catch (e) {}
        if (!lead || !lead.pixelId) {
            console.warn('[INVELO] utmify IC: no session (pixel has not stored the lead yet)');
            return;
        }
        var loc = window.location;
        var sourceUrl = (loc.protocol + '//' + loc.hostname + loc.pathname).replace(/\/+$/, '');
        fetch('https://tracking.utmify.com.br/tracking/v1/events', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type: 'InitiateCheckout',
                lead: lead,
                event: { sourceUrl: sourceUrl, pageTitle: (document.title || '').trim() || null }
            }),
            keepalive: true
        }).then(function () {
            console.log('[INVELO] utmify IC sent');
        }).catch(function (e) {
            console.warn('[INVELO] utmify IC failed', e);
        });
    } catch (e) {
        console.warn('[INVELO] utmify IC', e);
    }
}

function fireCheckoutPixels(mappedId) {
    var params = metaContentParams();
    if (mappedId) params.content_ids = [String(mappedId)];
    var eidAtc = inveloEventId('atc');
    var eidIc = inveloEventId('ic');
    trackMeta('AddToCart', params, eidAtc);
    trackMeta('InitiateCheckout', params, eidIc);
    fireUtmifyIc();
    return eidIc;
}

function goUrl(url) {
    setTimeout(function () { window.location.href = url; }, 400);
}

function pcDirectCheckout() {
    applyVariantForKit(selectedKit);
    var vidEl = document.getElementById('pc-variant-id');
    var vid = vidEl ? parseInt(vidEl.value, 10) : 0;
    if (!vid) {
        console.warn('[INVELO] no variant_id');
        return;
    }
    var veiculoEl = document.getElementById('pc-veiculo');
    var props = {};
    if (veiculoEl && veiculoEl.value) props['Vehicle'] = veiculoEl.value;

    var state = readDrState();
    var dest = mapVariantId(state, vid);
    var eidIc = fireCheckoutPixels(dest || vid);
    var qs = attrQuery({ event_id: eidIc });

    if (state && state.shopDomain && dest) {
        var url = 'https://' + state.shopDomain + '/cart/' + dest + ':1';
        var locQs = [];
        var cc = (window.INVELO_I18N && window.INVELO_I18N.country) ? window.INVELO_I18N.country() : '';
        if (cc) {
            locQs.push('country=' + encodeURIComponent(cc));
            locQs.push('localization[country]=' + encodeURIComponent(cc));
        }
        if (qs) locQs.push(qs);
        if (locQs.length) url += '?' + locQs.join('&');
        console.log('[INVELO] DarkRouter →', url);
        goUrl(url);
        return;
    }
    console.warn('[INVELO] DarkRouter map missing, falling back to /checkout', { vid: vid, shop: state && state.shopDomain, dest: dest });
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: vid, quantity: 1, properties: props })
            });
        })
        .then(function () { goUrl('/checkout' + (qs ? '?' + qs : '')); })
        .catch(function () { goUrl('/checkout'); });
}

function buyClick(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (!vehicleConfigured) {
        var target = document.getElementById('configurador');
        if (target) {
            var headerH = (document.querySelector('.header') || { offsetHeight: 60 }).offsetHeight;
            window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - headerH, behavior: 'smooth' });
        }
        return;
    }
    if (typeof updateVeiculoInput === 'function') updateVeiculoInput();
    pcDirectCheckout();
}

document.addEventListener('DOMContentLoaded', function () {

    // ========================================
    // MOBILE MENU
    // ========================================
    var menuToggle = document.getElementById('menuToggle');
    var menuClose  = document.getElementById('menuClose');
    var mobileMenu = document.getElementById('mobileMenu');
    var menuOverlay = document.getElementById('menuOverlay');
    var menuLinks  = document.querySelectorAll('.mobile-menu-links a');

    function openMenu() {
        mobileMenu.classList.add('active');
        menuOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
        mobileMenu.classList.remove('active');
        menuOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }

    if (menuToggle) menuToggle.addEventListener('click', openMenu);
    if (menuClose)  menuClose.addEventListener('click', closeMenu);
    if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);
    menuLinks.forEach(function (link) { link.addEventListener('click', closeMenu); });

    // ========================================
    // BEFORE / AFTER COMPARISON SLIDER
    // ========================================
    var slider      = document.getElementById('comparisonSlider');
    var handle      = document.getElementById('comparisonHandle');
    var beforeImage = slider ? slider.querySelector('.comparison-before') : null;

    if (slider && handle && beforeImage) {
        var isDragging = false;
        function updateSlider(x) {
            var rect = slider.getBoundingClientRect();
            var pos  = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
            var pct  = pos * 100;
            beforeImage.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
            handle.style.left = pct + '%';
        }
        slider.addEventListener('mousedown', function (e) { isDragging = true; updateSlider(e.clientX); e.preventDefault(); });
        document.addEventListener('mousemove', function (e) { if (isDragging) updateSlider(e.clientX); });
        document.addEventListener('mouseup',   function () { isDragging = false; });
        slider.addEventListener('touchstart', function (e) { isDragging = true; updateSlider(e.touches[0].clientX); }, { passive: true });
        document.addEventListener('touchmove', function (e) { if (isDragging) updateSlider(e.touches[0].clientX); }, { passive: true });
        document.addEventListener('touchend',  function () { isDragging = false; });
    }

    // ========================================
    // VEHICLE CONFIGURATOR
    // ========================================
    var marcaSelect     = document.getElementById('marca');
    var modeloSelect    = document.getElementById('modelo');
    var anoSelect       = document.getElementById('ano');
    var configLoading   = document.getElementById('configLoading');
    var configAvailable = document.getElementById('configAvailable');
    var availableModel  = document.getElementById('availableModel');
    var availableSub    = document.getElementById('availableSub');
    var veiculoInput    = document.getElementById('pc-veiculo');

    var defaultYears = [];
    for (var y = 2027; y >= 1997; y--) defaultYears.push(y);

    var vehicleData = {
        'ALFA ROMEO':    ['147','156','159','Giulia','Giulietta','MiTo','Stelvio','Tonale'],
        'AUDI':          ['A1','A3','A4','A5','A6','A7','A8','Q2','Q3','Q5','Q7','Q8','e-tron','S3','S5','TT'],
        'BMW':           ['1 Series','2 Series','3 Series','4 Series','5 Series','7 Series','X1','X2','X3','X4','X5','X6','X7','Z4','i3','i4','iX'],
        'BYD':           ['Atto 3','Dolphin','Han','Seal','Tang'],
        'CITROËN':       ['Berlingo','C1','C3','C3 Aircross','C4','C4 Cactus','C5','C5 Aircross','C5 X'],
        'CUPRA':         ['Born','Formentor','Leon','Terramar'],
        'DACIA':         ['Dokker','Duster','Jogger','Logan','Sandero','Spring'],
        'FIAT':          ['500','500X','Bravo','Panda','Punto','Tipo'],
        'FORD':          ['EcoSport','Fiesta','Focus','Galaxy','Kuga','Mondeo','Mustang','Puma','Ranger'],
        'HONDA':         ['Accord','Civic','CR-V','HR-V','Jazz'],
        'HYUNDAI':       ['i10','i20','i30','Ioniq 5','Ioniq 6','Kona','Santa Fe','Tucson'],
        'JAGUAR':        ['E-Pace','F-Pace','I-Pace','XE','XF'],
        'JEEP':          ['Avenger','Cherokee','Compass','Grand Cherokee','Renegade','Wrangler'],
        'KIA':           ['Ceed','EV6','Niro','Picanto','Sorento','Sportage','Stonic'],
        'LAND ROVER':    ['Defender','Discovery','Discovery Sport','Range Rover','Range Rover Evoque','Range Rover Sport'],
        'MERCEDES-BENZ': ['A-Class','B-Class','C-Class','E-Class','S-Class','CLA','GLA','GLB','GLC','GLE','GLS','Vito'],
        'MINI':          ['Cabrio','Clubman','Countryman','Hatchback'],
        'MITSUBISHI':    ['ASX','Eclipse Cross','L200','Outlander'],
        'NISSAN':        ['Ariya','Juke','Leaf','Micra','Qashqai','X-Trail'],
        'OPEL':          ['Astra','Corsa','Crossland','Grandland','Insignia','Mokka'],
        'PEUGEOT':       ['108','208','308','2008','3008','408','5008','508'],
        'PORSCHE':       ['911','Cayenne','Macan','Panamera','Taycan'],
        'RENAULT':       ['Arkana','Austral','Captur','Clio','Duster','Kadjar','Kangoo','Koleos','Mégane','Scenic','Zoe'],
        'SEAT':          ['Arona','Ateca','Ibiza','Leon','Tarraco'],
        'SKODA':         ['Enyaq','Fabia','Kamiq','Karoq','Kodiaq','Octavia','Superb'],
        'SUBARU':        ['Forester','Impreza','Outback','XV'],
        'SUZUKI':        ['Ignis','Jimny','S-Cross','Swift','Vitara'],
        'TESLA':         ['Model 3','Model S','Model X','Model Y'],
        'TOYOTA':        ['Aygo X','bZ4X','C-HR','Corolla','GR Supra','Hilux','Land Cruiser','Prius','RAV4','Yaris','Yaris Cross'],
        'VOLKSWAGEN':    ['Amarok','Arteon','Caddy','Golf','ID.3','ID.4','ID.5','Passat','Polo','T-Cross','T-Roc','Tiguan','Touareg','Up'],
        'VOLVO':         ['C40','EX30','S60','S90','V60','V90','XC40','XC60','XC90'],
    };

    // Kit elements
    var kitSelection  = document.getElementById('kitSelection');
    var kitBasico     = document.getElementById('kitBasico');
    var kitCompleto   = document.getElementById('kitCompleto');
    var totalCard     = document.getElementById('totalCard');
    var priceCard     = document.getElementById('priceCard');
    var stickyDefault = document.getElementById('stickyDefault');
    var stickyBuy     = document.getElementById('stickyBuy');
    var stickyPriceEl = document.getElementById('stickyPrice');

    function updateVeiculoInput() {
        if (!veiculoInput) return;
        if (vehicleConfigured) {
            veiculoInput.value = (marcaSelect.value + ' ' + modeloSelect.value + ' ' + anoSelect.value).trim();
        } else {
            veiculoInput.value = '';
        }
    }

    function setMoney(id, eur, kit) {
        var el = document.getElementById(id);
        if (el) el.textContent = fmt(eur, kit);
    }

    function updateKitUI() {
        if (kitBasico && kitCompleto) {
            kitBasico.classList.toggle('selected',   selectedKit === 'basico');
            kitCompleto.classList.toggle('selected', selectedKit === 'completo');
            var rb = document.getElementById('radioBasico');
            var rc = document.getElementById('radioCompleto');
            if (rb) rb.classList.toggle('checked', selectedKit === 'basico');
            if (rc) rc.classList.toggle('checked', selectedKit === 'completo');
        }

        var price    = PRICES[selectedKit] || PRICES.basico;
        var original = ORIGINALS[selectedKit] || ORIGINALS.basico;
        var disc     = DISCOUNTS[selectedKit] || DISCOUNTS.basico;

        setMoney('priceValue', PRICES.basico, 'basico');
        setMoney('kitBasicoPrice', PRICES.basico, 'basico');
        setMoney('kitBasicoOriginal', ORIGINALS.basico, 'basicoCompare');
        setMoney('kitCompletoPrice', PRICES.completo, 'completo');
        setMoney('kitCompletoOriginal', ORIGINALS.completo, 'completoCompare');
        setMoney('totalValue', price, selectedKit);
        setMoney('totalOriginal', original, selectedKit + 'Compare');
        var off = document.getElementById('totalOff');
        if (off) off.textContent = '−' + disc + '% OFF';
        if (stickyPriceEl) stickyPriceEl.textContent = fmt(price, selectedKit);

        applyVariantForKit(selectedKit);
    }

    function selectKit(kit) { selectedKit = kit; updateKitUI(); syncBuyButtons(); }

    if (kitBasico) {
        kitBasico.addEventListener('click',   function () { selectKit('basico');   /* AddToCart/InitiateCheckout handled by DarkRouter */ });
        kitCompleto.addEventListener('click', function () { selectKit('completo'); /* AddToCart/InitiateCheckout handled by DarkRouter */ });
    }

    function hideKitFlow() {
        if (kitSelection) kitSelection.style.display = 'none';
        if (totalCard)    totalCard.style.display    = 'none';
        if (priceCard)    priceCard.style.display    = '';
        if (stickyDefault) stickyDefault.style.display = '';
        if (stickyBuy)    stickyBuy.style.display    = 'none';
        vehicleConfigured = false;
        updateVeiculoInput();
        syncBuyButtons();
    }

    if (marcaSelect) {
        marcaSelect.addEventListener('change', function () {
            var marca = this.value;
            var t = window.INVELO_I18N && window.INVELO_I18N.t;
            modeloSelect.innerHTML = '<option value="">' + (t ? t('config.model') : 'Model') + '</option>';
            anoSelect.innerHTML    = '<option value="">' + (t ? t('config.year') : 'Year') + '</option>';
            configAvailable.style.display = 'none';
            hideKitFlow();

            if (marca && vehicleData[marca]) {
                modeloSelect.disabled = false;
                anoSelect.disabled    = true;
                vehicleData[marca].forEach(function (model) {
                    var opt = document.createElement('option');
                    opt.value = model; opt.textContent = model;
                    modeloSelect.appendChild(opt);
                });
            } else {
                modeloSelect.disabled = true;
                anoSelect.disabled    = true;
            }
        });

        modeloSelect.addEventListener('change', function () {
            var tYear = window.INVELO_I18N && window.INVELO_I18N.t;
            anoSelect.innerHTML = '<option value="">' + (tYear ? tYear('config.year') : 'Year') + '</option>';
            configAvailable.style.display = 'none';
            hideKitFlow();

            if (this.value) {
                anoSelect.disabled = false;
                defaultYears.forEach(function (year) {
                    var opt = document.createElement('option');
                    opt.value = year; opt.textContent = year;
                    anoSelect.appendChild(opt);
                });
            } else {
                anoSelect.disabled = true;
            }
        });

        anoSelect.addEventListener('change', function () {
            if (!this.value) return;
            var marca  = marcaSelect.value;
            var modelo = modeloSelect.value;
            var ano    = this.value;

            configLoading.style.display   = 'flex';
            configAvailable.style.display = 'none';
            hideKitFlow();

            setTimeout(function () {
                configLoading.style.display = 'none';
                configAvailable.style.display = 'flex';
                var t = window.INVELO_I18N && window.INVELO_I18N.t;
                if (availableModel) availableModel.textContent = t ? t('available').replace('{model}', modelo) : ('Available for ' + modelo);
                if (availableSub)   availableSub.textContent   = t ? t('availableSub').replace('{brand}', marca) : ('Made to measure · ' + marca);
                var cc = document.getElementById('pc-country');
                if (cc && window.INVELO_I18N && window.INVELO_I18N.country) cc.value = window.INVELO_I18N.country();

                // Kit card prices
                document.getElementById('kitBasicoPrice').textContent    = fmt(PRICES.basico, 'basico');
                document.getElementById('kitBasicoOriginal').textContent = fmt(ORIGINALS.basico, 'basicoCompare');
                document.getElementById('kitBasicoDiscount').textContent = '−' + DISCOUNTS.basico + '%';
                document.getElementById('kitCompletoPrice').textContent    = fmt(PRICES.completo, 'completo');
                document.getElementById('kitCompletoOriginal').textContent = fmt(ORIGINALS.completo, 'completoCompare');
                document.getElementById('kitCompletoDiscount').textContent = '−' + DISCOUNTS.completo + '%';

                var isPickup = ['Ranger','Hilux','L200','Navara','Amarok'].indexOf(modelo) >= 0;
                var tx = window.INVELO_I18N && window.INVELO_I18N.t;
                document.getElementById('kitExtraFeature').textContent = tx
                    ? tx(isPickup ? 'kit.f3pickup' : 'kit.f3')
                    : (isPickup ? 'Premium truck bed mat' : 'Premium trunk mat');
                document.getElementById('kitTitle').textContent = tx
                    ? tx(isPickup ? 'kit.pickupTitle' : 'kit.title')
                    : (isPickup ? 'Pickup truck kits' : 'Choose the right protection');

                selectedKit = 'completo';
                vehicleConfigured = true;
                if (kitSelection)  kitSelection.style.display  = '';
                if (totalCard)     totalCard.style.display     = '';
                if (priceCard)     priceCard.style.display     = 'none';
                if (stickyDefault) stickyDefault.style.display = 'none';
                if (stickyBuy)     stickyBuy.style.display     = '';
                updateKitUI();
                updateVeiculoInput();
                syncBuyButtons();

                setTimeout(function () {
                    kitSelection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 200);
            }, 800);
        });
    }

    // ========================================
    // SHOPIFY ADD-TO-CART FORM SUBMISSION
    // The BUY buttons (btnComprar and btnComprarSticky) are type=submit for this form.
    // ========================================
    var primecarForm = document.getElementById('primecar-form');
    if (primecarForm) {
        primecarForm.addEventListener('submit', function (e) {
            e.preventDefault();
            buyClick(e);
        });
    }
    ['btnComprar', 'btnComprarSticky'].forEach(function (id) {
        var b = document.getElementById(id);
        if (!b) return;
        b.setAttribute('type', 'button');
        b.addEventListener('click', buyClick);
    });

    // ========================================
    // SCROLL ANIMATIONS
    // ========================================
    var animatedElements = document.querySelectorAll('.beneficio-item, .depoimento-card, .detalhe-card, .stat-item');

    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var siblings = entry.target.parentElement.children;
                    var idx = Array.prototype.indexOf.call(siblings, entry.target);
                    setTimeout(function () { entry.target.classList.add('visible'); }, idx * 70);
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });
        animatedElements.forEach(function (el) { observer.observe(el); });
    } else {
        animatedElements.forEach(function (el) { el.classList.add('visible'); });
    }

    // ========================================
    // COUNTER ANIMATION
    // ========================================
    var statNumbers = document.querySelectorAll('.stat-number[data-target]');
    if ('IntersectionObserver' in window && statNumbers.length) {
        var counterObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var el = entry.target;
                    var target = parseInt(el.getAttribute('data-target'));
                    var suffix = el.getAttribute('data-suffix') || '';
                    var current = 0, step = target / 30;
                    var timer = setInterval(function () {
                        current += step;
                        if (current >= target) { current = target; clearInterval(timer); }
                        el.textContent = Math.floor(current) + suffix;
                    }, 40);
                    counterObserver.unobserve(el);
                }
            });
        }, { threshold: 0.5 });
        statNumbers.forEach(function (el) { counterObserver.observe(el); });
    }

    // ========================================
    // SMOOTH SCROLL
    // ========================================
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            var href = this.getAttribute('href');
            if (href === '#') return;
            e.preventDefault();
            var target = document.querySelector(href);
            if (target) {
                var headerH = (document.querySelector('.header') || {offsetHeight: 60}).offsetHeight;
                window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - headerH, behavior: 'smooth' });
            }
        });
    });

    // ========================================
    // HEADER SCROLL
    // ========================================
    var header = document.getElementById('header');
    window.addEventListener('scroll', function () {
        if (header) header.style.background = window.pageYOffset > 100 ? 'rgba(13,13,16,0.98)' : 'rgba(13,13,16,0.95)';
    }, { passive: true });

    // Initial variant (default kit = completo)
    applyVariantForKit(selectedKit);
    window.updateKitUI = updateKitUI;
    updateKitUI();
    syncBuyButtons();
    trackMeta('ViewContent', metaContentParams(), 'vc.' + (document.getElementById('pc-variant-id') || {}).value);
    document.addEventListener('invelo:market', function () {
        updateKitUI();
        var cc = document.getElementById('pc-country');
        if (cc && window.INVELO_I18N && window.INVELO_I18N.country) cc.value = window.INVELO_I18N.country();
    });
});

// ========================================
// LIGHTBOX
// ========================================
function openLightbox(src) {
    var lightbox = document.getElementById('lightbox');
    var img      = document.getElementById('lightboxImg');
    if (!lightbox || !img) return;
    img.src = src;
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeLightbox() {
    var lightbox = document.getElementById('lightbox');
    if (!lightbox) return;
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
}

document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
});
